module.exports = __webpack_public_path__ + "static/media/occasion-care-package.69b4ce79.png";